﻿define(['pubsub', 'moduleUtilities', 'generalUtilities', 'connectionService'], function(
    pubsub,
    moduleUtilities,
    generalUtilities
) {
    'use strict';
    /**
     * re_connection_utilities
     * @exports connectionUtilities
     * @author John Allan
     */
    //#region set up

    var module, values, getConnectionData, getConnectionDataResolved;

    module = {};
    /** @module */
    module.private = {};
    module.properties = {};
    values = {};

    values.totalConnected = 0;

    getConnectionData = Q.defer();
    getConnectionDataResolved = false;
    //#endregion

    //#region utilities
    module.private.getConnectionData = function() {
        if (generalUtilities.prop(RESAAS, 'User2.IsProfessional')) {
            pubsub.publish('uiNeeds.ConnectionBrowse', {});
        }
    };

    module.private.getConnectionInfo = function(values, userId, currentUserId) {
        if (currentUserId === userId) {
            return { isSelf: true };
        }

        if (getConnectionDataResolved) {
            return generalUtilities.prop(values, ['connections', userId].join('.'));
        } else {
            return { connectionInfoNotReady: true };
        }
    };

    //#endregion

    //#region pubsub event handlers

    /**
     * Handle data event returned from service, determines success of fail and calls the corresponding function.
     * @param {object} e The pubsub event.
     * @param {object} data Data object from service.
     */
    module.private.handleDataConnectionBrowse = function(e, data) {
        if (
            !generalUtilities.prop(data, 'response.status') &&
            generalUtilities.prop(data, 'response.statusText') !== 'error'
        ) {
            values.totalConnected = data.response.reduce(function(a, c) {
                if (c.Connected) {
                    return a + 1;
                }
                return a;
            }, 0);
            values.connections = generalUtilities.arrayToHash(data.response, 'UserId');
        } else {
            values.totalConnected = 0;
            values.connections = undefined;
        }

        getConnectionData.resolve(true);
        getConnectionDataResolved = true;
    };

    //#endregion

    /**
     * Initiates the module, creates a guid and binds dom events.
     * @param {object} [e] The pubsub event, optional depending module is self init or by pubsub event.
     * @param {object} [data] Data passed in by pubsub event, optional depending module is self init or by pubsub event.
     */
    module.private.init = function(e, data) {
        //module config
        module.properties.guid = data && data.guid ? data.guid : generalUtilities.uuid();

        //elements
        module.private.getConnectionData();
    };

    //#region external event bindings

    pubsub.subscribe('data.ConnectionBrowse', module.private.handleDataConnectionBrowse);
    //whenever a new connection is made, refresh the data
    pubsub.subscribe('data.ConnectionAdd', module.private.getConnectionData);

    //#endregion

    //#region public API
    module.getConnectionInfo = function(userId) {
        return module.private.getConnectionInfo(values, userId, RESAAS.User2.UserId);
    };

    module.getTotalConnected = function() {
        return values.totalConnected;
    };

    module.getConnectionPromise = function() {
        return getConnectionData.promise;
    };

    //#endregion

    module.private.init();

    //expose API
    return module;
});
